import React, { useState } from 'react';
import { Box, TextField, Button, Typography } from '@mui/material';
import Swal from 'sweetalert2';

Swal.mixin({
  customClass: {
    confirmButton: ''
  },
  buttonsStyling: true
});

const ForgotPasswordForm = ({ onClose }) => {
  const BASE_URL = process.env.REACT_APP_API_URL;

  const [form, setForm] = useState({
    username: '',
    resetCode: '',
    newPassword: '',
    confirmPassword: ''
  });
  const [step, setStep] = useState(1); // 1 = request, 2 = verify
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleRequest = async () => {
    setLoading(true);
    const res = await fetch(`${BASE_URL}/api/password-reset/forgot-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username: form.username })
    });
    const data = await res.json();
    if (res.ok) {
      setStep(2);
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Request Failed',
        text: data.error || 'Failed to send reset code',
        confirmButtonColor: '#A58E63'
      });
    }
    setLoading(false);
  };

  const handleReset = async () => {
    if (form.newPassword !== form.confirmPassword) {
      Swal.fire({
        icon: 'warning',
        title: 'Mismatch',
        text: 'Passwords do not match.',
        confirmButtonColor: '#A58E63'
      });
      return;
    }

    setLoading(true);
    const res = await fetch(`${BASE_URL}/api/password-reset/reset-password`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        username: form.username,
        resetCode: form.resetCode,
        newPassword: form.newPassword
      })
    });

    const data = await res.json();
    if (res.ok) {
      Swal.fire({
        icon: 'success',
        title: 'Password Reset',
        text: 'Your password has been successfully reset.',
        confirmButtonColor: '#A58E63'
      });
      onClose();
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Reset Failed',
        text: data.error || 'Unable to reset password',
        confirmButtonColor: '#A58E63'
      });
    }
    setLoading(false);
  };

  return (
    <Box sx={{ maxWidth: 400, mx: 'auto', mt: 4 }}>
      <Typography variant="h6" gutterBottom>
        {step === 1 ? 'Request Reset Code' : 'Reset Your Password'}
      </Typography>
      <TextField
        fullWidth
        label="Username"
        name="username"
        value={form.username}
        onChange={handleChange}
        sx={{ mb: 2 }}
        disabled={step === 2}
      />
      {step === 2 && (
        <>
          <TextField fullWidth name="resetCode" label="Reset Code" onChange={handleChange} sx={{ mb: 2 }} />
          <TextField fullWidth type="password" name="newPassword" label="New Password" onChange={handleChange} sx={{ mb: 2 }} />
          <TextField fullWidth type="password" name="confirmPassword" label="Confirm Password" onChange={handleChange} sx={{ mb: 2 }} />
        </>
      )}
      <Button fullWidth variant="contained" onClick={step === 1 ? handleRequest : handleReset} disabled={loading}>
        {step === 1 ? 'Send Reset Code' : 'Reset Password'}
      </Button>
      <Button fullWidth onClick={onClose} sx={{ mt: 1 }}>
        Cancel
      </Button>
    </Box>
  );
};

export default ForgotPasswordForm;